module.exports = __webpack_public_path__ + "img/fanwei.15093d3f.png";